<template>
	<base-user-list
		v-loading="loading"
		:users="users"
		detail-link="driver-edit"
		new-link="driver-new"
		show-filter
		@get-page="loadData" />
</template>

<script>
import { BaseUserList } from '@/components/Base';

export default {
	name: 'DriverList',
	components: { BaseUserList },
	data() {
		return {
			users: {},
			loading: false,
		};
	},
	methods: {
		async loadData(params) {
			this.loading = true;
			this.users = await this.$service.admin.getDriversList(params);
			this.loading = false;
		},
	},
};
</script>
